import React from "react";

const InnerContactForm = () => {
  return (
    <form
      action="https://formspree.io/f/xblogrjv"
      method="POST"
    >
      <div className="form-grp">
        <label htmlFor="name">
          <i className="fas fa-user"></i>
        </label>
        <input
          type="text"
          id="name"
          name="name"
          placeholder="Naam"
          required
        />
      </div>

      <div className="form-grp">
        <label htmlFor="phone">
          <i className="fas fa-phone"></i>
        </label>
        <input
          type="tel"
          id="phone"
          name="phone"
          placeholder="Telefoonnummer"
          required
        />
      </div>

      <div className="form-grp">
        <label htmlFor="email">
          <i className="fas fa-envelope"></i>
        </label>
        <input
          type="email"
          id="email"
          name="email"
          placeholder="E-mailadres"
          required
        />
      </div>

      <div className="form-grp">
        <label htmlFor="subject">
          <i className="fas fa-book"></i>
        </label>
        <input
          type="text"
          id="subject"
          name="subject"
          placeholder="Onderwerp"
          required
        />
      </div>

      <div className="form-grp">
        <label htmlFor="message">
          <i className="fas fa-comment-dots"></i>
        </label>
        <textarea
          id="message"
          name="message"
          placeholder="Hoe kunnen we u helpen? Laat hier uw bericht achter."
          required
        ></textarea>
      </div>

      {/* Optional: spam honeypot */}
      <input
        type="text"
        name="_gotcha"
        style={{ display: "none" }}
        tabIndex="-1"
        autoComplete="off"
      />

      <button type="submit" className="btn">
        Verstuur Bericht <span></span>
      </button>
    </form>
  );
};

export default InnerContactForm;
